<div class="remote-auth">
    <div class="rfid">{{rfId}}</div>
    <div class="status">{{status}}</div>
</div>
